import { rawAxios as axios } from "./axios";
import { api } from "./axios.config";

const API_URL = api.manageApiUrl;

export function getFeaturedEvents(params = {}) {
	const {
		search = "",
		city = null,
		country = null,
		featured_category = null,
	} = params;

	const queryParams = new URLSearchParams();

	if (search) queryParams.append("search", search);
	if (city) queryParams.append("city", city);
	if (country) queryParams.append("country", country);
	if (featured_category) queryParams.append("featured_category", featured_category);

	const queryString = queryParams.toString();
	const url = `${API_URL}/featured-events${queryString ? `?${encodeURI(queryString)}` : ""}`;

	return axios.get(url);
}